module.exports = __webpack_public_path__ + "asset/image-ic_category_21-abdf6c3505a598d1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/ic_category_21.svg
// module id = Lbh9
// module chunks = 0